import { AsyncPipe, DatePipe, KeyValuePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { ReportPageRoutingModule } from './report-routing.module';
import { ReportPageComponent } from './report.page';

@NgModule({
  declarations: [ReportPageComponent],
  imports: [
    ReportPageRoutingModule,
    IonicModule,
    TitleCasePipe,
    KeyValuePipe,
    MiscModule,
    DatePipe,
    ReactiveFormsModule,
    AsyncPipe
  ]
})
export class ReportPageModule {}
